import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { DollarSign } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SavingsCounter() {
  const [saved, setSaved] = useState(0);

  useEffect(() => {
    axios.get(`${API}/savings/summary`).then(r => {
      setSaved(r.data?.month?.saved || 0);
    }).catch(() => {});
  }, []);

  if (saved <= 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="flex items-center gap-2 px-3 py-2 rounded-lg bg-[var(--qn-success-muted)] border border-[var(--qn-success)]/20"
      data-testid="savings-counter"
    >
      <DollarSign className="w-4 h-4 text-[var(--qn-success)]" />
      <span className="text-sm font-mono font-semibold text-[var(--qn-success)]">
        Saved ${saved.toFixed(2)} this month
      </span>
    </motion.div>
  );
}
